module.exports = __webpack_public_path__ + "img/CameraOff.44f03e8a.svg";